import styled from 'styled-components'
import media from 'styled-media-query'

export const DefexContentStyled = styled.div`
	//
	${media.lessThan('medium')`
		order: 4;
	`}
	
	& > button {
		${media.lessThan('medium')`
			width: 100%;
		`}
	}
`

export const ContentTabsStyled = styled.nav`
	& > ul {
		display: flex;
		list-style: none;
		gap: 4px;
		padding: 0;
		margin: 0;

		li {
			button {
				background: ${({ theme }) => theme.colors.fourth};
				border-radius: 8px;
				border-top-left-radius: 0;
				border-top-right-radius: 0;
				border-bottom: 0.25rem solid ${({ theme }) => theme.colors.first};
				color: ${({ theme }) => theme.colors.first};
				cursor: pointer;
				flex-direction: row;
				gap: 4px;
				margin: 0;
				padding: 1rem 1rem 0.75rem;

				&.on {
					background: ${({ theme }) => theme.colors.first};
					box-shadow: 0px 8px 8px -6px rgba(0,0,0,0.5) inset;
					border-color: ${({ theme }) => theme.colors.second};
					color: ${({ theme }) => theme.colors.text.light};
				}
				
				&.off {}
				
				&.disabled {
					background: #ddd;
					border-color: #eee;
					color: #eee;
				}
			
				${media.lessThan('medium')`
					width: 100%;
					padding: 0.75rem;
					border-bottom-width: 0.175rem;
				`}
			}
		}
	}
`

export const ContentMainStyled = styled.div`
	& {
		padding: 2rem 0 0;

		h2 {
			color: ${({ theme }) => theme.colors.second};
			font-size: 28px;
			font-weight: 300;
			margin: 0 0 2rem;
		}

		h3 {
			color: ${({ theme }) => theme.colors.fourth};
			display: inline-block;
			font-size: 16px;
			font-weight: 500;
		}

		section > div {
			border-bottom: 1px solid #ccc;
			margin: 0 0 2.5rem;
			padding-bottom: 2.5rem;

			&:last-child {
				border-bottom: none;
			}
		}
			
		ul {
			list-style: none;
			padding: 0;
			margin: 0;
			
			li {
				color: ${({ theme }) => theme.colors.text.normal};
				font-size: 14px;
				line-height: 20px;
				margin: 0 0 0.5rem;

				span {
					opacity: 0.5;
				}
				
				strong {
					color: ${({ theme }) => theme.colors.text.darker};
					font-weight: 500;
					text-decoration: underline;
				}
			}
		}

		.empty {
			opacity: 0.25;
		}

		.nutrient {
			display: flex;
			flex-direction: row;
			gap: 1rem;
			
			${media.lessThan('medium')`
				flex-direction: column;
			`}

			.text {
				flex: 3;
			}

			.image {
				align-items: center;
				justify-content: center;
				display: flex;
				flex: 2;
				max-width: 350px;

				img {
					width: 100%;
					height: auto;
				}
			}
		}
	}
`